import {
  MDBBtn,
  MDBDatatable,
  MDBDateTimepicker,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRadio,
  MDBSelect,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useImperativeHandle, useRef, useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../views/popups/PopupLoader";
import AddOverride from "../../views/popups/callflow/AddOverride";
import ScheduleWeekDay from "./weekday";
import { getMisc, getSpecifSchedulesForCallFlow } from "../../apiclients/streamsapi_bridge";
import { set } from "react-hook-form";
import AddHolidays from "../../views/popups/callflow/AddHolidays";
import { useNavigate } from "react-router";
const SchduleView = forwardRef((props, ref) => {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [weekOption, setWeekOption] = useState("fulltime");
  const hNameRef = useRef();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [toTimerror, setToTimerror] = useState(null);
  const [fromTimerror, setFromTimerror] = useState(null);
  const [errroFlag, setErrorflag] = useState(false);

  const [timezone, settimezone] = useState([]);
  const [tzvalue, setTZValue] = useState(0);

  const [errorFlags, setErrorFlags] = useState({
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false
  });

  useEffect(() => {
    if (props.onValidationChange) {
      props.onValidationChange(Object.values(errorFlags).includes(true));
    }
  }, [errorFlags]);

  useImperativeHandle(ref, () => ({
    saveSchedule: () => {
      saveSchedule();
    }
  }));

  const addOverrideRef = useRef();
  const [addOverrideError, setAddOverrideError] = useState(false);

  const addHolidayRef = useRef();
  const [addHolidayError, setAddHolidayError] = useState(false);

  const [addOverride, setAddOverride] = useState(false);
  const toggleAddOverrride = () => {
    setAddOverride(!addOverride);
    setTimeout(() => {
      if (hNameRef && hNameRef.current) {
        hNameRef.current.focus();
      }
    }, 500);
  };

  const [isloading, setIsloading] = useState(false);
  const [schduleObj, setSchduleObj] = useState({
    schedule: { all_time: true },
    holidays: [],
    overrides: [],
  });
  const [addHolidayName, setAddHolidayName] = useState(null);
  const [addHolidayFrom, setAddHolidayFrom] = useState(null);
  const [addHolidayFromTime, setAddHolidayFromTime] = useState(null);
  const [addHolidayTo, setAddHolidayTo] = useState(null);
  const [addHolidayToTime, setAddHolidayToTime] = useState(null);
  const [addHoliday, setAddHoliday] = useState(false);
  const toggleAddHoliday = () => {
    setAddHoliday(!addHoliday);
    setAddHolidayName("");
    setAddHolidayTo("")
    setAddHolidayToTime("")
    setAddHolidayFromTime("")
    setAddHolidayFrom("")
    setError("");
    setTimeout(() => {
      if (hNameRef && hNameRef.current) {
        hNameRef.current.focus();
      }
    }, 500);
  };

  function formtimeChange(value) {
    if (!value.trim()) {
      setFromTimerror({ addHolidayFrom: { message: "Please enter From date" } })
    } else {
      setAddHolidayFrom(value.split(",")[0]?.trim());
      setAddHolidayFromTime(value.split(",")[1]?.trim());
      setFromTimerror({ addHolidayFrom: {} });
    }

  }
  function totimeChange(value) {
    if (!value.trim()) {
      setToTimerror({ addHolidayTo: { message: "Please enter To date" } });
    } else {
      setAddHolidayTo(value.split(",")[0].trim());
      setAddHolidayToTime(value.split(",")[1].trim());
      setToTimerror({ addHolidayTo: {} });
    }
  }
  const toggleAddHolidays = () => {
    setAddHoliday(!addHoliday);
    setTimeout(() => {
      if (hNameRef && hNameRef.current) {
        hNameRef.current.focus();
      }
    }, 500);
  };

  function createHolidaysSchedule(allrow) {
    toggleAddHolidays();
    schduleObj.holidays.push(allrow);
  }
  async function fetchSchedule(scid) {
    try {
      sessionStorage.setItem("current_link", "huntgroup");
      setIsloading(true);
      const response = await getSpecifSchedulesForCallFlow(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        scid
      );
      const rawData = await response.json();
      console.log(rawData);
      console.log("---------------------------------------");
      if (!rawData.errors || !rawData.errors.length > 0) {
        console.log("---------------444444444444444------------------------");
        rawData.schedule_id = scid;
        setSchduleObj(rawData);
        setWeekOption(rawData.schedule.all_time ? "fulltime" : "weekly");
        setTZValue(rawData?.sctimezone)
      }
    } catch (e) {
    } finally {
      setIsloading(false);
    }
  }
  // const createHoliday = (e) => {
  //   if (!addHolidayName || addHolidayName.trim() == "") {
  //     setError({ name: { message: "Please enter Name" } });
  //     if (hNameRef) {
  //       hNameRef.current.focus();
  //     }
  //     return;
  //   } else if (!addHolidayFrom || addHolidayFrom.trim() == "") {
  //     setFromTimerror({ addHolidayFrom: { message: "Please enter From date" } });
  //     return;
  //   } else if (!addHolidayTo || addHolidayTo.trim() == "") {
  //     setToTimerror({ addHolidayTo: { message: "Please enter To date" } });
  //     return;
  //   } else {
  //     setError(null);
  //     setToTimerror(null);
  //     setFromTimerror(null);
  //   }
  //   toggleAddHoliday();
  //   let allrow = {
  //     id: new Date().getTime() + "",
  //     name: addHolidayName,
  //     from: addHolidayFrom + " " + addHolidayFromTime,
  //     to: addHolidayTo + " " + addHolidayToTime,
  //     position:
  //       "From " +
  //       addHolidayFrom +
  //       " " +
  //       addHolidayFromTime +
  //       " to " +
  //       addHolidayTo +
  //       " " +
  //       addHolidayToTime,
  //   };
  //   schduleObj.holidays.push(allrow);
  //   //setAddHolidaData([...addHolidaData, allrow]);
  // };
  const holidayChange = (e) => {
    const value = e.target.value;
    setAddHolidayName(value);

    if (!value.trim()) {
      setError({ name: { message: "Please enter Name" } });
      if (hNameRef) {
        hNameRef.current.focus();
      }
    } else {
      setError({ name: {} }); // Clear the error
    }
  };

  const numToDayKey = { 1: "sun", 2: "mon", 3: "tue", 4: "wed", 5: "thu", 6: "fri", 7: "sat" };
  const dayName = (day) => {
    // Normalize: DB stores numeric (1=Sun...7=Sat), UI uses string keys ("sun","mon"...)
    const key = (typeof day === "number" || !isNaN(+day)) && numToDayKey[+day] ? numToDayKey[+day] : day;
    return key == "sun" ? "Sunday" : key == "mon" ? "Monday" : key == "tue" ? "Tuesday"
      : key == "wed" ? "Wednesday" : key == "thu" ? "Thursday" : key == "fri" ? "Friday" : "Saturday";
  };

  const createOverrideSchedule = (entries) => {
    toggleAddOverrride();
    const newRows = (Array.isArray(entries) ? entries : [entries]).map((data) => ({
      id: data.tfenabled ? new Date().getTime() + "_" + data.day : `${data.fromTime}_${data.day}_${data.toTime}`,
      name: data.name,
      day: data.day,
      dayname: dayName(data.day),
      from: data.tfenabled ? "12:00 AM" : data.fromTime,
      to: data.tfenabled ? "11:59 PM" : data.toTime,
      tfenabled: data.tfenabled,
      fullday: data.tfenabled + "" == "true" ? "Yes" : "No",
      position: data.tfenabled ? data.day + " Full Day" : data.day + " From " + data.fromTime + " to " + data.toTime,
    }));
    schduleObj.overrides.push(...newRows);
    setSchduleObj({ ...schduleObj });
  };
  useEffect(() => {
    let scid =
      props.schid && props.schid
        ? props.schid.schedule_id
        : null;

    fetchSchedule(scid);
    getCompanyInfoMisc();
    setTZValue(props?.node?.data?.selected_object?.scheduleTimezone);
    console.log("current node ::::", JSON.stringify(props.node))
  }, []);
  async function getCompanyInfoMisc() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["global_company_info"],
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("getCompanyInfoMisc for ::::::::::::: " + JSON.stringify(tdata));
    let timezoneOptions = tdata?.misc?.global_company_info?.timezones ?? [];
    settimezone(
      timezoneOptions.map((item) => {
        const [location, offset] = item.time_zone.split("  ");
        return {
          text: location,
          secondaryText: offset,
          value: parseInt(item.tid),
        };
      })
    );

  }
  let hldata = [];
  let oodata = [];
  const actionData2 = {
    columns: [
      { label: "Name", field: "name" },
      { label: "Day", field: "dayname" },
      { label: "From", field: "from" },
      { label: "To", field: "to" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: (() => {
      let lastSeenName = "";
      const sorted = [...(schduleObj.overrides ?? [])].sort((a, b) => a.name.localeCompare(b.name));
      return sorted.map((row) => {
        row.from = row.from || row.from_time;
        row.to = row.to || row.to_time;
        row.dayname = row.dayname || dayName(row.day);
        row.id = row.id || `${row.from}_${row.day}_${row.to}`;
        oodata.push(row);
        const displayName = row.name === lastSeenName ? "" : row.name;
        lastSeenName = row.name;
        return {
          ...row,
          name: displayName,
          delete: (
            <>
              <MDBIcon
                onClick={(e) => deleteOverride(e, row)}
                fas
                style={{ cursor: "pointer" }}
                icon="times"
                color="primary"
              />
            </>
          ),
        };
      });
    })(),
  };
  const actionDataAH = {
    columns: [
      { label: "Name", field: "name" },
      { label: "From", field: "from" },
      { label: "To", field: "to" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows:
      schduleObj.holidays &&
      schduleObj.holidays.map((row) => {
        row.id = new Date().getTime() + "";
        row.position = "From " + row.from + " to " + row.to;
        hldata.push(row);
        return {
          ...row,
          delete: (
            <>
              <MDBIcon
                onClick={(e) => deleteOverrideH(e, row)}
                fas
                style={{ cursor: "pointer" }}
                icon="times"
                color="primary"
              />
            </>
          ),
        };
      }),
  };

  const deleteOverride = (e, row) => {
    const updatedOverrides = oodata.filter((od) => od.id != row.id);
    setSchduleObj({ ...schduleObj, overrides: updatedOverrides });
  };
  const deleteOverrideH = (e, row) => {
    console.log(row);
    let tah = hldata.filter((ah) => ah.holiday_id != row.holiday_id);
    schduleObj.holidays = tah;
    setSchduleObj({ ...schduleObj });
  };

  const onupdate = (tobject) => {
    console.log(tobject);

    let tdayObj = {
      from_time: tobject.fromTime,
      to_time: tobject.toTime,
      selected: tobject.enabled,
      twenty_four: tobject.tfenabled,
    };
    console.log(tobject.day);
    console.log(schduleObj.schedule.weekly_schedule);
    let tAllObj = [];
    if (tobject.day === "Sunday") {
      schduleObj.schedule.weekly_schedule.sun = tdayObj;
    } else if (tobject.day === "Monday") {
      tAllObj = schduleObj.schedule.weekly_schedule.mon = tdayObj;
    } else if (tobject.day === "Tuesday") {
      tAllObj = schduleObj.schedule.weekly_schedule.tue = tdayObj;
    } else if (tobject.day === "Wednesday") {
      tAllObj = schduleObj.schedule.weekly_schedule.wed = tdayObj;
    } else if (tobject.day === "Thursday") {
      tAllObj = schduleObj.schedule.weekly_schedule.thu = tdayObj;
    } else if (tobject.day === "Friday") {
      tAllObj = schduleObj.schedule.weekly_schedule.fri = tdayObj;
    } else if (tobject.day === "Saturday") {
      tAllObj = schduleObj.schedule.weekly_schedule.sat = tdayObj;
    }
    console.log(schduleObj.schedule.weekly_schedule);
  };

  const onweeklyError = (errorInfo) => {
    const { flag, day } = errorInfo; // Extract flag and day from errorInfo
    console.log("error state :::", JSON.stringify(errorFlags))
    setErrorFlags((prevFlags) => ({
      ...prevFlags,
      [day.toLowerCase()]: flag, // Set the error flag for the specific day
    }));

    if (flag) {
      console.log(`Error occurred on ${day}`);
    } else {
      console.log(`No error on ${day}`);
    }
  };

  const saveSchedule = async (e) => {
    let tSObj = {};
    tSObj.schedule_id = props?.schid?.schedule_id;
    tSObj.schedule_name =  props?.schid?.label;
    tSObj.all_time = weekOption === "fulltime";
    tSObj.weekly_schedule = schduleObj.schedule.weekly_schedule;

    tSObj.overrides = { add_overrides: [] };
    tSObj.holidays = { add_holidays: [] };
    schduleObj.overrides.map((override) => {
      tSObj.overrides.add_overrides = [
        ...tSObj.overrides.add_overrides,
        {
          from_time: override.from,
          to_time: override.to,
          twenty_four: override.tfenabled,
          name: override.name,
          day: override.day,
        },
      ];
    });
    schduleObj.holidays.map((holiday) => {
      tSObj.holidays.add_holidays = [
        ...tSObj.holidays.add_holidays,
        { from: holiday.from, to: holiday.to, name: holiday.name },
      ];
    });
    // Removing the disabled weekly_schedules additional parametere , which are not required..
    for (const weekDay in tSObj.weekly_schedule) {
      if (
        !tSObj.weekly_schedule[weekDay] ||
        tSObj.weekly_schedule[weekDay].selected === false
      ) {
        tSObj.weekly_schedule[weekDay] = {
          selected: false,
        };
      }
    }
    console.log(
      `length checking:: ${tSObj.overrides.add_overrides?.length ?? 0}`
    );
    console.log(
      `tzvalue:: ${tzvalue}`
    );
    tSObj.timezone = tzvalue;

    if ((tSObj.overrides.add_overrides?.length ?? 0) == 0) {
      delete tSObj.overrides.add_overrides;
      delete tSObj.overrides;
    }
    if ((tSObj.holidays.add_holidays?.length ?? 0) == 0) {
      delete tSObj.holidays.add_holidays;
      delete tSObj.holidays;
    }

    console.log(`data::${JSON.stringify(tSObj)}`);

    console.log(`data::${JSON.stringify(tSObj)}`);
    props.onSave(tSObj, props.node, 1);
    props.onClose();
  };

  const selectRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const openUsersPopup = () => {
    setDropdownOpen(true);
  }

  const closeUsersPopup = () => {
    setDropdownOpen(false);
  }

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      console.log("Clicked outside dropdown");
      setDropdownOpen(false);
    }
  };



  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);




  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <output className="me-2">
                <MDBSpinner size="sm" tag="span" />
              </output>
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div className="tel-numbers mt-1">
        <strong>Weekly Schedule</strong>
      </div>
      <div className="d-flex align-items-center justify-content-start mt-2">
        <MDBRadio
          name="inlineRadio"
          id="inlineRadio1"
          value="fulltime"
          label="24/7"
          inline
          checked={weekOption === "fulltime"}
          onChange={() => setWeekOption("fulltime")}
        />
        <MDBRadio
          name="inlineRadio"
          id="inlineRadio2"
          value="weekly"
          label="Weekly Schedule"
          inline
          checked={weekOption === "weekly"}
          onChange={() => setWeekOption("weekly")}
        />


        <div class="d-flex align-items-center ps-4">
          <div class="tel-numbers">Timezone : </div>
          <div class="d-flex">
            <div className="w-100">
              <div class="ms-2 " ref={selectRef}>
                <MDBSelect
                  //   style={{ width: "210px" }}
                  search
                  className="timeZone"
                  label={false}
                  data={timezone}
                  open={dropdownOpen}
                  onOpen={() => openUsersPopup()}
                  onClosed={() => closeUsersPopup()}
                  value={tzvalue}
                  onChange={(e) => {
                    if (e && e.value) {
                      const selectedValue = parseInt(e.value);
                      setTZValue(selectedValue);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>

      </div>
      {weekOption === "weekly" && (
        <>
          {schduleObj.schedule.weekly_schedule && (
            <>
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.sun}
                day="Sunday"
                tfrom={schduleObj.schedule.weekly_schedule.sun.from_time}
                tto={schduleObj.schedule.weekly_schedule.sun.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.sun.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.sun.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.mon}
                day="Monday"
                tfrom={schduleObj.schedule.weekly_schedule.mon.from_time}
                tto={schduleObj.schedule.weekly_schedule.mon.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.mon.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.mon.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.tue}
                day="Tuesday"
                tfrom={schduleObj.schedule.weekly_schedule.tue.from_time}
                tto={schduleObj.schedule.weekly_schedule.tue.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.tue.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.tue.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.wed}
                day="Wednesday"
                tfrom={schduleObj.schedule.weekly_schedule.wed.from_time}
                tto={schduleObj.schedule.weekly_schedule.wed.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.wed.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.wed.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.thu}
                day="Thursday"
                tfrom={schduleObj.schedule.weekly_schedule.thu.from_time}
                tto={schduleObj.schedule.weekly_schedule.thu.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.thu.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.thu.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.fri}
                day="Friday"
                tfrom={schduleObj.schedule.weekly_schedule.fri.from_time}
                tto={schduleObj.schedule.weekly_schedule.fri.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.fri.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.fri.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule.sat}
                day="Saturday"
                tfrom={schduleObj.schedule.weekly_schedule.sat.from_time}
                tto={schduleObj.schedule.weekly_schedule.sat.to_time}
                tfenabled={schduleObj.schedule.weekly_schedule.sat.twenty_four}
                enabled={schduleObj.schedule.weekly_schedule.sat.selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
            </>
          )}
        </>
      )}

      <div className="add-numbermain">
        <div className="tel-numbers mt-1">
          <strong>Override</strong>
        </div>
        <MDBBtn onClick={toggleAddOverrride}>
          <MDBIcon fas icon="plus" className="me-2" />
          Add Override
        </MDBBtn>
      </div>
      <div className="weeklyTable">

        <MDBDatatable noFoundMessage="No Records" hover data={actionData2} pagination={false} />
        
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers mt-1">
          <strong>Holiday</strong>
        </div>
        <MDBBtn onClick={toggleAddHoliday}>
          <MDBIcon fas icon="plus" className="me-2" />
          Add Holiday
        </MDBBtn>
      </div>
      <div className="weeklyTable">
        <MDBDatatable
          sortField="Name"
          noFoundMessage="No Records"
          hover
          data={actionDataAH}
          pagination={false}
        />
      </div>

      {addOverride && (
        <PopupLoader
          size="lg"
          // className="modal-sm"
          title={t("addOverride")}
          content={
            <AddOverride
              ref={addOverrideRef}
              onClose={toggleAddOverrride}
              availablescd={schduleObj.overrides}
              onSuccess={createOverrideSchedule}
              onValidationChange={(hasError) => setAddOverrideError(hasError)}
            />
          }
          footer={
            <>
              <MDBBtn color="secondary" onClick={toggleAddOverrride}>
                {t("close")}
              </MDBBtn>
              <MDBBtn
                disabled={addOverrideError}
                onClick={(e) => {
                  if (addOverrideRef.current) {
                    addOverrideRef.current.onsubmit();
                  }
                }}
              >
                {t("add")}
              </MDBBtn>
            </>
          }
          onShow={setAddOverride}
          onClose={toggleAddOverrride}
        />
      )}
      {addHoliday && (
        <PopupLoader
          // size="sm"
          // className="modal-sm"
          title={t("addHoliday")}
          content={
            <AddHolidays
              ref={addHolidayRef}
              onClose={toggleAddHolidays}
              onSuccess={createHolidaysSchedule}
              open={addHoliday}
              holidays={schduleObj.holidays}
              onValidationChange={(hasError) => setAddHolidayError(hasError)}
            />
          }
          footer={
            <>
              <MDBBtn color="secondary" onClick={toggleAddHolidays}>
                {t("close")}
              </MDBBtn>
              <MDBBtn
                disabled={addHolidayError}
                onClick={(e) => {
                  if (addHolidayRef.current) {
                    addHolidayRef.current.createHoliday();
                  }
                }}
              >
                {t("add")}
              </MDBBtn>
            </>
          }
          onShow={setAddHoliday}
          onClose={toggleAddHolidays}
        />
      )}
      {/* <MDBModal open={addHoliday} setShow={setAddHoliday}>
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Add Holiday</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleAddHoliday}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="tel-numbers">
                <strong>{t("name")}</strong>
              </div>
              <div className="form pt-1 w-100">
                <input
                  type="text"
                  ref={hNameRef}
                  className="form-control w-100 form-outline"
                  onChange={(e) => holidayChange(e)}
                  value={addHolidayName}
                  maxLength={15}
                />
                {error && error.name && (
                  <p className="text-danger">{error.name.message}</p>
                )}
              </div>

              <div className="d-flex justify-content-between">
                <div className="tel-numbers mt-2 w-50">
                  <strong>{t("from")}</strong>
                  <div className="form pt-1 w-100">
                    <MDBDateTimepicker
                      dateFormat="mm/dd/yyyy"
                      timeformat="hh:mm A"
                      defaultDate={addHolidayFrom}
                      defaultTime={addHolidayFromTime}
                      inputToggle
                      value={
                        !addHolidayFrom
                          ? ""
                          : addHolidayFrom + "," + addHolidayFromTime
                      }
                      onChange={(value) => {
                        formtimeChange(value)
                      }}
                      
                    />
                    {fromTimerror && fromTimerror.addHolidayFrom && (
                      <p className="text-danger">
                        {fromTimerror.addHolidayFrom.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="tel-numbers mt-2 w-50">
                  <strong className="ms-2">{t("to")}</strong>
                  <div className="form pt-1 w-100 ps-2">
                    <MDBDateTimepicker
                      dateFormat="mm/dd/yyyy"
                      timeformat="hh:mm A"
                      defaultDate={addHolidayTo}
                      defaultTime={addHolidayToTime}
                      inputToggle
                      value={
                        !addHolidayTo
                          ? ""
                          : addHolidayTo + "," + addHolidayToTime
                      }
                      onChange={(value) => {
                        totimeChange(value)
                      }}
                    />
                    {toTimerror && toTimerror.addHolidayTo && (
                      <p className="text-danger">
                        {toTimerror.addHolidayTo.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter className="mb-3 me-3">
              <MDBBtn color="secondary" onClick={toggleAddHoliday}>
                Close
              </MDBBtn>
              <MDBBtn onClick={(e) => createHoliday(e)}>Add</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal> */}
    </>
  );
});

export default SchduleView;
